import "./Solutions.module.css";
import Header from "@/reusable_sections/Header";
import YourTailoredRecruitmentSolutions from "./sections/YourTailoredRecruitmentSolutions";
import ExploreOurSpecializedSolutions from "./sections/ExploreOurSpecializedSolutions";
import Footer from "@/reusable_sections/Footer";
import SpecializedRecruitmentSolutionBlockOne from "./sections/SpecializedRecruitmentSolutionBlockOne";
import SpecializedRecruitmentSolutionBlockTwo from "./sections/SpecializedRecruitmentSolutionBlockTwo";
export default function SolutionsPage() {
  return <div>
      <Header />
      <YourTailoredRecruitmentSolutions />
      <ExploreOurSpecializedSolutions />
      <SpecializedRecruitmentSolutionBlockOne />
      <SpecializedRecruitmentSolutionBlockTwo />
      <Footer />
    </div>;
}